import 'promise-polyfill/src/polyfill'
import Vue from 'vue'
import axios from 'axios'
import row from './components/row'
import Paginate from 'vuejs-paginate'

Vue.component('paginate', Paginate);

axios.defaults.headers.common['X-Requested-With'] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found');
}

new Vue({
    el: "#app",
    components: {
        'row': row,
    },
    data: {
        results: [],
        lang: {},
        onLoading: false,
        continent: "",
        treatment: "",
        bakingDegree: "",
        range: "",
        inventory: "",
        pageCount: 0
    },
    mounted: function () {
        this.lang = window.lang;
        if (window.continent !== undefined) {
            this.continent = window.continent;
        }
        this.search();
    },
    methods: {
        search: function () {
            this.remote(window.api);
        },
        PageHandler: function (page) {
            const url = window.api + "?page=" + page;
            this.remote(url);
        },
        remote: function (url) {
            this.results = [];
            if (!this.onLoading) {
                this.onLoading = true;
                const data = {
                    continent: this.continent,
                    treatment: this.treatment,
                    bakingDegree: this.bakingDegree,
                    range: this.range,
                    inventory: this.inventory
                };
                axios.post(url, data).then((response) => {
                    this.results = response.data.result;
                    this.pageCount = response.data.count;
                    this.onLoading = false;
                }).catch((error) => {
                    this.onLoading = false;
                    this.results = [];
                    this.pageCount = 0;
                });
            }
        }
    }
});
